import { render, staticRenderFns } from "./change-email.vue?vue&type=template&id=38c80150&"
import script from "./change-email.vue?vue&type=script&lang=js&"
export * from "./change-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports